import React, { useRef } from 'react';
import Navbar from './Navbar';
import HeroSection from './HeroSection';
import Footer from './Footer';
import './Home.css';
import IntroSection from './IntroSection';
import ContactSection from './ContactSection';
import SEO, { personSchema, professionalServiceSchema, webSiteSchema } from '../components/SEO';
import NewsletterSubscribe from '../components/NewsletterSubscribe';

function Home() {
  const introRef = useRef(null);

  const scrollToIntro = () => {
    if (introRef.current) {
      introRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const schema = [webSiteSchema(), personSchema(), professionalServiceSchema()];

  return (
    <div className="home">
      <SEO
        title="Contract Specialist London"
        description="Pooja Biswal — contract specialist London, LLM (Distinction) Queen Mary. Expert contract review, drafting and negotiation for freelancers and businesses across the UK."
        keywords="contract specialist London, contract review UK, freelance contract advice, NDA drafting London, service agreement review, commercial contracts consultant UK, contract management, legal contracts for freelancers"
        canonical="/"
        schema={schema}
      />
      <Navbar />
      <HeroSection onKnowMoreClick={scrollToIntro} />
      
      {/* Add id="intro" to IntroSection wrapper */}
      <div id="intro">
        <IntroSection ref={introRef} />
      </div>
      
      
      {/* Add id="contact" to ContactSection wrapper */}
      <div id="contact">
        <ContactSection />
      </div>
      
      <NewsletterSubscribe
        theme="studio"
        defaultLists={['studio']}
        kicker="Stay in the loop"
        title="Contract clarity, straight to your inbox."
        subtitle="Practical insight on contracts, freelancing, and doing business well — never more than once a week."
      />

      <Footer />
    </div>
  );
}

export default Home;
